"use strict";

if (module.hot) {
  module.hot.accept();
}

import mvTypingAnimation from "./js/components/mvTypingAnimation";
import scrollAnimation from "./js/components/scrollAnimation";
import hamburgerMenu from "./js/components/hamburgerMenu";
import carousel from "./js/components/carousel";
import seeMore from "./js/components/seeMore";

document.addEventListener(
  'DOMContentLoaded',
  () => {
    mvTypingAnimation();
    scrollAnimation();
    hamburgerMenu();
    carousel();
    seeMore();
  },
  false
);